import { Button } from "@/modules/common/components/button";
import Dialog from "@/modules/common/components/dialog";
import { useCategories } from "@/modules/products/hooks/useCategories";
import { useLocationStore } from "@/store/index";
import { MapPin, Menu, X } from "lucide-react";
import Link from "next/link";
import { useParams } from "next/navigation";
import { CurrencySelector } from "./currency-selector";
import { useState } from "react";
import { useIsMobile } from "@/lib/hooks/useIsMobile";
import { LocationSelector } from "./location-selector";

export const HeaderMobileMenu = () => {
  const [open, setOpen] = useState(false);
  // 1024 must match the `lg:hidden` wrapper that renders this button in
  // header.tsx. With the default 768px gate the button rendered but the dialog
  // stayed shut between 768-1023px, where the desktop menu is hidden too.
  const isMobile = useIsMobile(1024);
  const isReallyOpen = open && isMobile;

  if (!isMobile && open) {
    setOpen(false);
  }

  return (
    <Dialog
      open={isReallyOpen}
      onOpenChange={setOpen}
      contentClassName="bg-cream dark:bg-cream"
      trigger={
        <Button
          onClick={() => setOpen(true)}
          variant="ghost"
          size="icon"
          className="text-green-main hover:bg-green-main/10"
        >
          <Menu className="h-6 w-6" />
        </Button>
      }
      size="full"
    >
      <MenuContent onClose={() => setOpen(false)} />
    </Dialog>
  );
};

const MenuContent = ({ onClose }: { onClose?: () => void }) => {
  const { data } = useCategories();
  const categories = data?.response?.product_categories || [];
  const params = useParams();
  const countryCode = params.countryCode as string;

  const { setOpenModal, province, municipality } = useLocationStore();

  return (
    <div className="grid grid-cols-[1fr_auto]">
      <div className="space-y-2">
        <p className="font-achiko text-green-main">Categorías</p>
        <ul className="font-inter space-y-2 text-sm opacity-90">
          {categories.map((c) => (
            <li key={c.id}>
              <Link
                href={`/${countryCode}/products?category_id=${c.id}&filter=departamentos`}
                onClick={onClose}
              >
                {c.name}
              </Link>
            </li>
          ))}
        </ul>

        <p className="font-achiko text-green-main mt-6">Moneda</p>
        <div className="w-1/2">
          <CurrencySelector />
        </div>

        <p className="font-achiko text-green-main mt-6">Ubicación</p>

        <LocationSelector />
      </div>
    </div>
  );
};
